import moment from 'moment';
import { compose, lifecycle, withHandlers, withPropsOnChange, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import withTimezone from '../../../../../auth/utils/withTimezone';
import { getEndDate, getEndDateForAPI, getStartDate, getStartDateForAPI } from '../../../filters/selectors';
import withDefaultEndingDate from '../../../filters/containers/withDefaultEndingDate';
import { selectStartDate, selectEndDate } from '../../../actions';
import {
  getCustomReportFilters,
  getBarbersForReport,
  getShopsForReport,
  getReportDefinitionById,
  isFiltersDirty,
  isAllFiltersUnchecked,
  getCRFilteredItems,
} from '../../selectors';
import {
  downloadCsv,
  downloadPdf,
  initFilter,
  fetchReportData,
  resetReportData,
  setFiltersDirty,
} from '../../actions';
import Filters from './CustomReportFilters';
import { ChurnZeroService, RUN_CUSTOM_REPORT } from '../../../../../../modules/infra/observability/churnzero';

export default compose(
  withTimezone,
  withRouter,
  connect(
    (state, ownProps) => {
      const reportDefinition = getReportDefinitionById(state, ownProps.params.id);
      return {
        startDate: getStartDate(state),
        endDate: getEndDate(state),
        isFetching: Boolean(state.loadingBar),
        isSubmitDisabled:
          !isFiltersDirty(state)
          || Boolean(state.loadingBar)
          || isAllFiltersUnchecked(state, reportDefinition),
        startDateApi: getStartDateForAPI(state),
        endDateApi: getEndDateForAPI(state),
        barbersForReportFilters: getBarbersForReport(state),
        shopsForReportFilters: getShopsForReport(state),
        filters: getCustomReportFilters(state, reportDefinition),
        filteredItems: getCRFilteredItems(state, reportDefinition),
        reportDefinition,
        reportId: ownProps.params.id,
      };
    },
    {
      selectStartDate,
      selectEndDate,
      initFilter,
      fetchReportData,
      resetReportData,
      setFiltersDirty,
    },
  ),
  withProps(() => ({
    showCsvExport: false,
    disableBarberFilter: true,
  })),
  withHandlers({
    onDateChange: props => (start, end) => {
      props.selectStartDate(start);
      props.selectEndDate(end);
      props.setFiltersDirty();
    },
    applyFilter: props => () => {
      props.fetchReportData(props.reportId, props.filters, props.filteredItems);
      ChurnZeroService.track(RUN_CUSTOM_REPORT);
    },
    onExportToCsv: props => () => {
      downloadCsv(props.reportId, props.filters);
    },
    onExportToPdf: props => () => {
      downloadPdf(props.reportId, props.filters);
    },
  }),
  withPropsOnChange(['reportDefinition'], (props) => {
    if (props.reportDefinition) {
      props.initFilter('barber', props.barbersForReportFilters);
      props.initFilter('shop', props.shopsForReportFilters);
      props.setFiltersDirty();
      props.resetReportData();
    }
  }),
  lifecycle({
    componentDidMount() {
      const isInitialized = this.props.startDate !== null || this.props.endDate !== null;
      if (!isInitialized) {
        const startDate = moment().tz(this.props.timezone).toDate();
        const endDate = moment().tz(this.props.timezone).toDate();
        this.props.onDateChange(startDate, endDate);
      }
    },
  }),
  withDefaultEndingDate(),
)(Filters);
